export default "__VITE_ASSET__c393ede9__"